import React, { useState, useEffect, useRef } from "react";
import { changeRegion, fetchRegions } from "../services/api";
import "../styles/VPNSection.css";

function VPNSection({ selectedDeviceId, onShowToast }) {
  const [selectedRegion, setSelectedRegion] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [regions, setRegions] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const loadRegions = async () => {
      try {
        const data = await fetchRegions();
        setRegions(data);
      } catch (err) {
        setError("Failed to load regions");
        console.error(err);
      }
    };

    loadRegions();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleRegionChange = (region) => {
    setSelectedRegion(region);
    setSearchTerm(region);
    setIsDropdownOpen(false);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setIsDropdownOpen(true);
  };

  const filteredRegions = Object.entries(regions).filter(([_, name]) => {
    const regionName = typeof name === "object" ? name.name : name;
    return regionName.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedDeviceId) {
      onShowToast("Please select a device first", "error");
      return;
    }

    try {
      setLoading(true);
      let response = await changeRegion(selectedDeviceId, selectedRegion);

      if (response === 200) {
        onShowToast("Region changed successfully", "success");
        setSelectedRegion("");
        setSearchTerm("");
      } else {
        onShowToast("Something went wrong", "error");
      }
    } catch (err) {
      setError("Failed to change region");
      onShowToast("Failed to change region", "error");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="vpn-section">
      <h3>Change Region</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <div className="custom-select" ref={dropdownRef}>
            <input
              type="text"
              placeholder="Search region..."
              value={searchTerm}
              onChange={handleSearchChange}
              onFocus={() => setIsDropdownOpen(true)}
              className="search-input"
              disabled={!selectedDeviceId || loading}
            />
            {isDropdownOpen && (
              <div className="dropdown-list">
                {filteredRegions.map(([code, name]) => {
                  const regionName =
                    typeof name === "object" ? name.name : name;
                  return (
                    <div
                      key={code}
                      className={`dropdown-item ${
                        selectedRegion === regionName ? "selected" : ""
                      }`}
                      onClick={() => handleRegionChange(regionName)}
                    >
                      {regionName}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          <button
            type="submit"
            disabled={!selectedDeviceId || !selectedRegion || loading}
            className="submit-button"
          >
            {loading ? "..." : "→"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default VPNSection;
